import { RoutesConstant } from '../../constants/routes.constant';

export const LOGO_ICON_SIZE = 32;

export const menuStatusStorageKey = 'SIDEBAR_MENU_OPENED';

export const isCandidatesRoute = (path: string): boolean => {
  return (
    !path.startsWith(RoutesConstant.CANDIDATES_GROUPS.ARCHIVE) &&
    !path.startsWith(RoutesConstant.CANDIDATES_GROUPS.FAVOURITE) &&
    !path.includes('candidate/') &&
    path.startsWith(RoutesConstant.CANDIDATES)
  );
};
